require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-scott-mantei.json") })
        }
      }, "path---blog-author-scott-mantei");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-scott-mantei!./.cache/json/blog-author-scott-mantei.json
// module id = 705
// module chunks = 231608221292675